import { createListFilters, IOption } from '../../../../../components'

export type AvaliacoesPendentesFilters = {
  paciente: string
  protocolo: string
  empresa?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<AvaliacoesPendentesFilters>({
    paciente: '',
    protocolo: '',
    empresa: undefined,
  })
